<template>
  <div class="modal fade">
    <div class="modal-dialog" v-bind:class="{
        'modal-lg': modalLg
      }">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header"></slot>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ppt-modal',
  props: ['modalLg'],
};
</script>

<style lang="scss" scoped>
  .close {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/utilities/modal.vue